import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Users, LayoutDashboard } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PeopleLayoutProps {
  children: ReactNode;
}

const NAV_ITEMS = [
  { label: 'Visão Geral', href: '/people', icon: LayoutDashboard, end: true },
  { label: 'Colaboradores', href: '/people/employees', icon: Users, end: false },
];

export default function PeopleLayout({ children }: PeopleLayoutProps) {
  return (
    <div className="p-6 md:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Sub-navigation */}
        <nav className="flex items-center gap-1 overflow-x-auto pb-1">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.href}
                to={item.href}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {children}
      </div>
    </div>
  );
}
